import { FlightStatus, NotificationType } from '@connect-x-app/shared-domain-models';
import { create } from 'zustand';

type FlightRoomSessionState = {
  pendingNotificationType: NotificationType | undefined;
  selectedFlightRoomId: string | null;
  selectedFlightRoomTab: FlightStatus;
};

type FlightRoomSessionActions = {
  setPendingNotificationType: (type: NotificationType | undefined) => void;
  setSelectedFlightRoomId: (roomId: string | null) => void;
  setSelectedFlightRoomTab: (status: FlightStatus) => void;
};

type FlightRoomSessionStore = FlightRoomSessionState & FlightRoomSessionActions;

export const useFlightRoomSessionStore = create<FlightRoomSessionStore>(set => ({
  pendingNotificationType: undefined,
  selectedFlightRoomId: null,
  selectedFlightRoomTab: FlightStatus.ACTIVE,
  setPendingNotificationType: type => set({ pendingNotificationType: type }),
  setSelectedFlightRoomId: roomId => set({ selectedFlightRoomId: roomId }),
  setSelectedFlightRoomTab: tab => set({ selectedFlightRoomTab: tab }),
}));
